// @flow
import React, { Component } from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import LazyLoad from "react-lazy-load";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import classNames from "classnames";

import type { $Site } from "flow/types";

type $Props = {
  aboutLink: string,
  classes: Object,
  site: $Site,
  hasPosts: Array<Object>,
};

type $State = {
  name: string,
  image: string | null,
  linkVerbage: string,
};

class LeftBio extends Component<$Props, $State> {
  constructor(props) {
    super(props);

    const getName = () => {
      if (props.agent) {
        return `${props.agent.firstName || ""} ${props.agent.lastName || ""}`;
      } else if (props.site.officeId && props.office) {
        return props.office.name || "";
      } else if (props.site.teamId && props.team) {
        return props.team.name || "";
      } else {
        return "";
      }
    };

    const getImage = () => {
      if (props.agent) {
        return props.agent.picture || null;
      } else if (props.site.officeId && props.office) {
        return props.office.logo || null;
      } else if (props.site.teamId && props.team) {
        return props.team.logoPath || null;
      }
    };

    const getlinkVerbage = () => {
      if (props.agent) {
        return "me";
      } else if (props.site.officeId && props.office) {
        return "us";
      } else if (props.site.teamId && props.team) {
        return "us";
      } else {
        return "me";
      }
    };

    const name = getName();
    const image = getImage() || null;
    const linkVerbage = getlinkVerbage();

    this.state = {
      name,
      image,
      linkVerbage,
    };
  }
  render() {
    const { classes, site, aboutLink, hasPosts }: $Props = this.props;
    const { name, image, linkVerbage }: $State = this.state;

    return (
      <div className={classes.root}>
        <Typography
          className={classNames({
            [classes.headline]: true,
            [classes.centeredHeadline]: !hasPosts,
          })}
          type="heading3"
          gutterBottom
        >
          About {name}
        </Typography>
        {image ? (
          <LazyLoad offset={100} width={200}>
            <div className={classes.imageContainer}>
              <img src={image} alt={name} />
            </div>
          </LazyLoad>
        ) : null}
        <div className={classes.bio}>
          {site &&
            site.homepageBio && (
              <div dangerouslySetInnerHTML={{ __html: site.homepageBio }} />
            )}
          <Typography type="body" gutterTop gutterBottom>
            <a className={classes.link} href={aboutLink}>
              Read more about {linkVerbage}
            </a>
          </Typography>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flex: "0 1 auto",
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: "0 16px",
    [theme.breakpoints(768)]: {
      flex: (props) => (props.hasPosts ? "0 1 58.3333%" : "0 1 100%"),
    },
  },
  headline: {
    flex: "1 1 100%",
    marginBottom: theme.spacing.unit * 1.5,
  },
  centeredHeadline: {
    textAlign: "center",
  },
  imageContainer: {
    flex: "0 1 auto",
    "& img": {
      display: "block",
      position: "relative",
      margin: "0 auto",
      width: "100%",
      maxWidth: "200px",
      height: "auto",
    },
    [theme.breakpoints(768)]: {
      flex: "0 0 33.3333%",
    },
  },
  bio: {
    flex: "0 1 auto",
    padding: "0",
    fontSize: "14px",
    lineHeight: "18px",
    [theme.breakpoints(768)]: {
      flex: "0 0 66.66666%",
      padding: "8px 16px 0",
    },
  },
  link: {
    display: "block",
    marginTop: theme.spacing.unit * 1.5,
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
  },
});

export default withGlobalContext(withStyles(styles)(LeftBio));
